import { Stack, Typography, type TypographyProps } from '@mui/material';
import type { ReactNode } from 'react';

import { Icon } from '@/components/shared/icon';

export const EmptyStateContent = ({
  title,
  description,
  icon,
  media,
  primaryAction,
  secondaryAction,
  titleVariant,
  descriptionVariant,
  gap,
  textGap,
  maxWidth,
}: {
  title?: ReactNode;
  description?: ReactNode;
  icon?: string | ReactNode;
  media?: ReactNode;
  primaryAction?: ReactNode;
  secondaryAction?: ReactNode;
  titleVariant: TypographyProps['variant'];
  descriptionVariant: TypographyProps['variant'];
  gap: string;
  textGap: string;
  maxWidth: string;
}) => {
  const iconElement =
    typeof icon === 'string' ? <Icon iconClass={icon} /> : icon;
  const actions = [secondaryAction, primaryAction].filter(Boolean);

  return (
    <Stack
      sx={{
        alignItems: 'center',
        gap,
        maxWidth,
        textAlign: 'center',
      }}
    >
      {media}
      {iconElement}
      <Stack sx={{ alignItems: 'center', gap: textGap }}>
        {title && (
          <Typography variant={titleVariant} align='center'>
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant={descriptionVariant} align='center'>
            {description}
          </Typography>
        )}
      </Stack>
      {actions.length > 0 && (
        <Stack direction='row' sx={{ gap: '12px', alignItems: 'center' }}>
          {actions}
        </Stack>
      )}
    </Stack>
  );
};
